import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { Draggable } from "react-beautiful-dnd";
import { FaGripVertical } from "react-icons/fa";
import { SECTION_ORDER_LABELS } from "../../utils/constants/proposalSectionOrder";
import "./proposalSortable.css";

const useDraggableInPortal = () => {
  const portalRef = useRef(null);

  useEffect(() => {
    const portal = document.createElement("div");
    portal.className = "proposal-section-drag-portal";
    document.body.appendChild(portal);
    portalRef.current = portal;
    return () => {
      document.body.removeChild(portal);
      portalRef.current = null;
    };
  }, []);

  return (provided, snapshot, child) => {
    if (snapshot.isDragging && portalRef.current) {
      return createPortal(child, portalRef.current);
    }
    return child;
  };
};

const SortableSection = ({ id, index, disabled, children }) => {
  const label = SECTION_ORDER_LABELS[id] || id;
  const renderDraggable = useDraggableInPortal();

  return (
    <Draggable draggableId={id} index={index} isDragDisabled={!!disabled}>
      {(provided, snapshot) =>
        renderDraggable(
          provided,
          snapshot,
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            className={`proposal-sortable-section${
              snapshot.isDragging ? " is-dragging" : ""
            }`}
            style={provided.draggableProps.style}
          >
            {!disabled && (
              <button
                type="button"
                className="proposal-drag-handle"
                title={`Drag to reorder: ${label}`}
                aria-label={`Drag to reorder ${label}`}
                {...provided.dragHandleProps}
              >
                <FaGripVertical />
              </button>
            )}
            {children}
          </div>
        )
      }
    </Draggable>
  );
};

export default SortableSection;
